module.exports = __webpack_public_path__ + "static/img/camerafor.7983a37.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bottom/white/camerafor.png
// module id = pXud
// module chunks = 24